import { render } from "./ProductChart.vue?vue&type=template&id=9eca6d34&scoped=true"
import script from "./ProductChart.vue?vue&type=script&lang=js"
export * from "./ProductChart.vue?vue&type=script&lang=js"

import "./ProductChart.vue?vue&type=style&index=0&id=9eca6d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eca6d34"]])

export default __exports__